// src/componentes/common/notify.js
// Imperative toast API — call notify.success/error/info/warning from anywhere.

let _dispatch = null;

export function _registerToastDispatch(fn) {
  _dispatch = fn;
}

// BUG-7: evita que se apilen toasts idénticos (mismo mensaje+tipo) cuando una
// operación falla y se reintenta o dispara varias veces. Se ignora un toast
// repetido si el mismo apareció en los últimos _DEDUP_MS.
const _recent = new Map();
const _DEDUP_MS = 3000;

function notify(message, type = "info", duration = 4000) {
  if (!_dispatch) return;
  const msg = String(message);
  const key = `${type}::${msg}`;
  const now = Date.now();
  const last = _recent.get(key);
  if (last && now - last < _DEDUP_MS) return; // duplicado reciente → ignorar
  _recent.set(key, now);
  // Limpieza perezosa para no crecer sin límite.
  if (_recent.size > 50) {
    for (const [k, t] of _recent) {
      if (now - t > _DEDUP_MS) _recent.delete(k);
    }
  }
  _dispatch({ message: msg, type, duration, id: now + Math.random() });
}

notify.success = (msg, duration) => notify(msg, "success", duration);
notify.error   = (msg, duration) => notify(msg, "error",   duration ?? 5000);
notify.warning = (msg, duration) => notify(msg, "warning", duration);
notify.info    = (msg, duration) => notify(msg, "info",    duration);

export default notify;
